/**
 * Normaliza texto para busca accent-insensitive.
 * Remove acentos, converte para minúsculas e trima.
 */
export function normalizeSearch(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Verifica se `text` contém `query` de forma accent-insensitive.
 */
export function matchesSearch(
  text: string | null | undefined,
  query: string
): boolean {
  if (!text || !query) return false;
  return normalizeSearch(text).includes(normalizeSearch(query));
}
